import script from "./enyzjy.vue?vue&type=script&setup=true&lang=js"
export * from "./enyzjy.vue?vue&type=script&setup=true&lang=js"

import "./enyzjy.vue?vue&type=style&index=0&id=3ae00bdf&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ae00bdf"]])

export default __exports__